module.exports = __webpack_public_path__ + "static/media/logo-header.83402f48.svg";